// eslint-disable-next-line no-unused-vars
export const loginAbilities = (can: any) => {
  can('VIEW', 'CLUB_TABLE')
}
